import React from 'react';
import { PageLayout } from './PageLayout';
import { DocLayout } from './DocLayout';
export function PageWrapper(_ref) {
  var _mdx$fields;
  let {
    children,
    props: {
      data: {
        mdx
      }
    }
  } = _ref;
  if (!(mdx !== null && mdx !== void 0 && (_mdx$fields = mdx.fields) !== null && _mdx$fields !== void 0 && _mdx$fields.pageType)) return children;
  switch (mdx.fields.pageType) {
    case 'doc':
      return /*#__PURE__*/React.createElement(DocLayout, {
        title: mdx.fields.title,
        tableOfContents: mdx.tableOfContents,
        editLink: mdx.fields.editLink
      }, children);
    case 'page':
      return /*#__PURE__*/React.createElement(PageLayout, {
        title: mdx.fields.title
      }, children);
    default:
      return children;
  }
}